import { ProductSummaryBlockDefinition } from 'components/common-form/sidePanel/docToolbar/summary/builder/model';
import { FormattedMessage } from 'components/shared/Intl';
import type { IntlKey } from 'locales';
import type { ReactNode } from 'react';
import { FC } from 'react';
import type { BatchWorkspaceVersion, QuoteWorkspaceVersion } from 'state/userPreferences/userPreferences.model';

import { ProductSummaryFieldsList } from './FieldsList';

export interface ProductNodeBuilderProps {
  tabId: string;
  node: ProductSummaryBlockDefinition;
  level: number;
  quoteWorkspaceVersion: QuoteWorkspaceVersion;
  batchWorkspaceVersion: BatchWorkspaceVersion;
  mustForceAdvancedMode: boolean;
  tabIndex?: number;
}
type DefaultBlockLayoutProps = { children: ReactNode; id: string; labelKey?: IntlKey };
export function DefaultBlockLayout({ children, id, labelKey }: DefaultBlockLayoutProps) {
  return (
    <table className="table table-sm mb-3" data-e2e={`product-summary-block-${id}`}>
      <thead>
        <tr>
          <th className="border-top-0 ps-0 text-start" col-span="2">
            <span className=" badge badge-flat-primary badge-xl rounded-pill">
              <h5 className="mb-0">
                <FormattedMessage id={labelKey} />
              </h5>
            </span>
          </th>
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </table>
  );
}
export const DefaultBlock: FC<ProductNodeBuilderProps> = ({
  node: { id, properties },
  level,
  tabId,
  quoteWorkspaceVersion,
  batchWorkspaceVersion,
  mustForceAdvancedMode,
}) => {
  return (
    <DefaultBlockLayout id={id} labelKey={`form.${id}` as IntlKey}>
      <ProductSummaryFieldsList
        level={level}
        nodes={properties}
        tabId={tabId}
        quoteWorkspaceVersion={quoteWorkspaceVersion}
        batchWorkspaceVersion={batchWorkspaceVersion}
        mustForceAdvancedMode={mustForceAdvancedMode}
      />
    </DefaultBlockLayout>
  );
};
DefaultBlock.displayName = 'DefaultBlock';
